<template>
    <Header/>

    <main>
        <div class="container max-w-7xl mx-auto">
            <div class="sm:flex flex-row sm:items-start">
                <div class="sm:w-1/4">
                    <div class="panel p-2">
                        <user-panel/>
                    </div>
                    <div class="panel py-2">
                        <server-stats/>
                    </div>
                    <div class="panel hidden sm:block">
                        <top10-rank/>
                        <staff-list/>
                    </div>
                </div>
                <div class="sm:w-3/4">
                    <div class="h-64 flex-row items-start hidden sm:flex">
                        <div class="w-2/3 new-custom-border h-full">
                            <carousel/>
                        </div>
                        <div class="w-1/3 h-full">
                            <div
                                class="hover:drop-shadow-2xl hover:drop-shadow-red-500 h-32 flex text-center justify-center items-center border-8 border-red-900/20 bg-gradient-to-b hover:border-red-900/50 transition-all from-red-700 to-red-800 text-xl uppercase font-bold">
                                <a :href="route('shop.home')">
                                    <p class="mb-2"><i class="fa-solid fa-bag-shopping fa-2xl"></i></p>
                                    <p>{{ $t("Item shop") }}</p>
                                </a>
                            </div>
                            <div
                                class="hover:drop-shadow-2xl hover:drop-shadow-red-500 h-32 flex text-center justify-center items-center border-8 border-red-900/20 bg-gradient-to-b hover:border-red-900/50 transition-all from-emerald-500 to-emerald-600 text-xl uppercase font-bold">
                                <a :href="route('download')">
                                    <p class="mb-2"><i class="fa-solid fa-download fa-2xl"></i></p>
                                    <p>{{ $t("Download") }}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="backdrop-blur-xl px-4 pt-8 pb-16 new-custom-border">
                        <Alert v-if="$page.props.flash.message !== null" :type="$page.props.flash.message.type">
                            <template #title>
                                {{ $page.props.flash.message.title }}
                            </template>
                            {{ $page.props.flash.message.message }}
                        </Alert>

                        <slot/>
                    </div>
                </div>
            </div>
        </div>
    </main>

    <Footer/>
</template>

<script setup>
import Header from "@/Shared/Header"
import Footer from "@/Shared/Footer"
import {usePage} from '@inertiajs/inertia-vue3'
import Top10Rank from "@/Shared/Top10Rank";
import UserPanel from "@/Shared/UserPanel";
import Alert from "@/Shared/Alert";
import Carousel from "@/Shared/Carousel";
import {computed, onBeforeMount} from "vue";
import StaffList from "@/Shared/StaffList";
import {loadLanguageAsync} from "laravel-vue-i18n";
import ServerStats from "@/Shared/ServerStats";

const config = computed(() => usePage().props.value.config)
const pageName = computed(() => store.getters.getPageName)
const userLocale = usePage().props.value.locale;

onBeforeMount(() => {
    loadLanguageAsync(userLocale)
})
</script>
